module.exports = __webpack_public_path__ + "img/pica2.a842cc20.png";